import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { colors } from '../../constants/styleConstants';
import TextButton from '../TextButton';
import Button from '../Button';
import { TP } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';

const useStyles = makeStyles(theme => ({
  buttonsBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
  },
  backButton: {
    fontWeight: 'bold',
    color: colors.blue,
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

const StepperButtonsBlock = ({ activeStepNumber, activeStep, isLastStep, isStepUpdating, nextStepText }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.buttonsBlock}>
      {activeStepNumber === 0 ? (
        <span>{activeStep?.info}</span>
      ) : (
        <TextButton
          onClick={() => {
            if (activeStep.backStepAction && typeof activeStep.backStepAction === 'function') {
              activeStep.backStepAction();
            }
          }}
          startIcon={<ArrowBackIosIcon style={{ fill: colors.blue }} />}
          className={classes.backButton}
        >
          {t(`${TP}.FN_PREVIOUS`)}
        </TextButton>
      )}
      <Button
        onClick={() => {
          if (activeStep.nextStepAction && typeof activeStep.nextStepAction === 'function') {
            activeStep.nextStepAction();
          }
        }}
        endIcon={<ArrowForwardIosIcon style={{ fill: colors.white }} />}
        isLoading={isStepUpdating}
      >
        {isLastStep ? t(`${TP}.FN_EDITSEASON_FINISH`) : t(nextStepText)}
      </Button>
    </div>
  );
};

StepperButtonsBlock.propTypes = {
  activeStepNumber: PropTypes.number,
  activeStep: PropTypes.shape({
    backStepAction: PropTypes.func.isRequired,
    nextStepAction: PropTypes.func.isRequired,
    info: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  }),
  isLastStep: PropTypes.bool,
  isStepUpdating: PropTypes.bool,
  nextStepText: PropTypes.string,
};

StepperButtonsBlock.defaultProps = {
  isLastStep: false,
  isStepUpdating: false,
  nextStepText: `${TP}.FN_SAVE_NEXT`,
};

export default StepperButtonsBlock;
